module.exports = __webpack_public_path__ + "static/green_icon-57bb100a7e8cb7ef89a92072650b947f.png";